import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'Service/api/api';

const getCoordinateByLocation = createAsyncThunk(
  'location/getCoordinateByLocation',
  ({ location, fieldName }: { location: string; fieldName: string }) => {
    try {
      return api.location.getCoordinateByLocation(location, fieldName);
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

const getRouteDistanceAndDuration = createAsyncThunk(
  'location/getRouteDistanceAndDuration',
  ({
    coordinateFrom,
    coordinateTo,
  }: {
    coordinateFrom: string;
    coordinateTo: string;
  }) => {
    try {
      return api.location.getRouteDistanceAndDuration(
        coordinateFrom,
        coordinateTo,
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

const getMilesOut = createAsyncThunk(
  'location/getMilesOut',
  ({
    coordinateFrom,
    coordinateTo,
  }: {
    coordinateFrom: string;
    coordinateTo: string;
  }) => {
    try {
      return api.location.getMilesOut(coordinateFrom, coordinateTo);
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export { getCoordinateByLocation, getRouteDistanceAndDuration, getMilesOut };
